import React from "react";
import { Stack, Typography } from "@mui/material";
import {
  HubButton,
  HubButtonGroup,
  HubDialogTitle,
  HubIcon,
} from "../../components";
import { useFormContext } from "react-hook-form";

const baseStack = {
  direction: "row",
  gap: "5px",
  alignItems: "center",
};

export const ShippingTitleLabel = ({ number = "" }) => (
  <Stack {...baseStack}>
    <HubIcon icon="Archive" size={12} />
    <Typography variant="dropDownText" sx={{ textWrap: "nowrap" }}>
      {number || "Create New Shipment"} /
    </Typography>
    <Typography variant="dropDownText" sx={{ textWrap: "nowrap" }}>
      Details
    </Typography>
  </Stack>
);

const ReturnTypes = [
  { id: 0, label: "To Customer" },
  { id: 1, label: "To Vendor" },
];

const ShipmentDetailsDialogTitle = ({ number, onClose = () => {} }) => {
  const { watch, setValue } = useFormContext();
  const setReturnHelper = (type) => {
    setValue("returning", !!type);
  };
  const returnType = watch("returning");

  const RightContent = (
    <Stack direction="row" gap="10px">
      <HubButtonGroup
        buttons={ReturnTypes}
        selected={Number(!!returnType)}
        setSelected={setReturnHelper}
        disabled={!!number}
      />
      <HubButton
        variant="contained"
        color="neutral"
        size="xsmall"
        label="Save"
        type="submit"
      />
    </Stack>
  );
  return (
    <HubDialogTitle
      leftContent={<ShippingTitleLabel number={number} />}
      onClose={onClose}
      contextMenu={RightContent}
    />
  );
};

export default ShipmentDetailsDialogTitle;
